<template>
  <div class="px-0">
    <div class="table-responsive mb-2">
      <!-- Header Actions Slot -->
      <div class="mb-2">
        <slot name="header-actions"></slot>
      </div>

      <button v-if="showAddbutton" class="float-right btn btn-primary mr-3" @click="handleAddAction">Add Promotion</button>

      <div class="mb-3" />

      <table :id="table_id" class="table table-striped table-bordered">
        <thead>
          <tr>
            <th 
              v-for="column in columns" 
              :key="column.key || column.header"
              :style="{ width: column.width }"
            >
              {{ column.header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="getRowKey(item, index)">
            <td 
              v-for="column in columns" 
              :key="column.key || column.header"
              :style="{ width: column.width }"
            >
              <!-- Regular column content -->
              <span v-if="column.type !== 'action'">
                {{ getCellValue(item, column, index) }}
              </span>
              
              <!-- Action column content -->
              <div v-else-if="column.type === 'action'" class="action-buttons">
                <button
                  v-for="action in column.actions"
                  :key="action.key"
                  :class="getActionClass(action, item, index)"
                  @click="handleAction(action, item, index)"
                  :disabled="action.disabled && action.disabled(item, index)"
                >
                  {{ getActionLabel(action, item, index) }}
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- Footer Slot -->
    <slot name="footer"></slot>
  </div>
</template>

<script>
export default {
  name: 'TableComponent',

  props: {
    data: {
      type: Array,
      required: true,
      default: () => []
    },
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    table_id: {
      type: String,
      default: 'dynamic-table'
    },
    rowKey: {
      type: [String, Function],
      default: null
    },
    showAddbutton: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      user: JSON.parse(localStorage.getItem("user"))
    };
  },

  methods: {
    getCellValue(item, column, index) {
      if (typeof column.body === 'function') {
        return column.body(item, index);
      } else if (typeof column.body === 'string') {
        // Handle dot notation for nested properties
        return this.getNestedValue(item, column.body);
      } else {
        return column.body;
      }
    },

    getNestedValue(obj, path) {
      return path.split('.').reduce((current, prop) => {
        return current && current[prop] !== undefined ? current[prop] : '';
      }, obj);
    },

    getActionClass(action, item, index) {
      let baseClass = 'btn ';
      
      if (action.class) {
        if (typeof action.class === 'function') {
          baseClass += action.class(item, index);
        } else {
          baseClass += action.class;
        }
      } else {
        baseClass += 'btn-primary';
      }

      // Add block and rounded classes if specified
      if (action.block) baseClass += ' btn-block';
      if (action.rounded) baseClass += ' btn-rounded';
      
      return baseClass;
    },

    getActionLabel(action, item, index) {
      if (typeof action.label === 'function') {
        return action.label(item, index);
      }
      return action.label || action.key;
    },

    handleAction(action, item, index) {
      if (action.handler && typeof action.handler === 'function') {
        action.handler(item, index, action.key);
      }
      
      // Emit event to parent
      this.$emit('action', {
        action: action.key,
        item,
        index
      });
    },

    getRowKey(item, index) {
      if (this.rowKey) {

        if (typeof this.rowKey === 'function') {
          return this.rowKey(item, index);
        }
        return item[this.rowKey];
      }
      return index;
    },

    handleAddAction() {
      const hasRole = this.user.roles.some(role => role.name == "Marketing");

      if(hasRole) {
        $('#add-promo-modal').modal('show');
      } else {
        $('#error-modal').modal('show');
      }
    }
  }
}
</script>

<style scoped>
.action-buttons button {
  margin-bottom: 5px;
}

.action-buttons button:not(:last-child) {
  margin-right: 5px;
}

/* You can move your existing table styles here or keep them in parent component */
</style>

<style>
#advanced-purchased-tbl_wrapper .dt-buttons .btn.buttons-excel {
  margin-bottom: 0px !important;
  background-color: #AC8400 !important;
  border-color: #AC8400 !important;
  color: white !important;
  border-radius: 5px !important;
}

#advanced-purchased-tbl_wrapper .dt-buttons .btn.buttons-excel:hover {
  background-color: #AC8400 !important;
  border-color: #AC8400 !important;
}

#advanced-purchased-tbl_wrapper .dt-buttons .btn.buttons-excel:focus {
  background-color: #AC8400 !important;
  border-color: #AC8400 !important;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
}

#advanced-logs-tbl_wrapper .dt-buttons .btn.buttons-excel {
  margin-bottom: 0px !important;
  background-color: #AC8400 !important;
  border-color: #AC8400 !important;
  color: white !important;
  border-radius: 5px !important;
}

#advanced-logs-tbl_wrapper .dt-buttons .btn.buttons-excel:hover {
  background-color: #AC8400 !important;
  border-color: #AC8400 !important;
}

#advanced-logs-tbl_wrapper .dt-buttons .btn.buttons-excel:focus {
  background-color: #AC8400 !important;
  border-color: #AC8400 !important;
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25) !important;
}
</style>
